import { createGlobalStyle } from 'styled-components';
import media from 'styled-media-query';

const GlobalStyle = createGlobalStyle`
    :root {
        --font-size: 14px;
        --header-height: 70px;
        --main-search-height: 175px;

		--main-color: ${process.env.REACT_APP_COLOR_MAIN};
		--main-color-light: #a2bff4;
		--main-color-lighten: #c1d4f7;

        ${media.greaterThan('medium')`
            --font-size: 16px;
            --header-height: 90px;
            --main-search-height: 250px;
        `}
	}

	html, body, div, span, applet, object, iframe,
	h1, h2, h3, h4, h5, h6, p, blockquote, pre,
	a, abbr, acronym, address, big, cite, code,
	del, dfn, em, img, ins, kbd, q, s, samp,
	small, strike, strong, sub, sup, tt, var,
	b, u, i, center,
	dl, dt, dd, ol, ul, li,
	fieldset, form, label, legend,
	table, caption, tbody, tfoot, thead, tr, th, td,
	article, aside, canvas, details, embed,
	figure, figcaption, footer, header, hgroup,
	menu, nav, output, ruby, section, summary,
	time, mark, audio, video {
		margin: 0;
		padding: 0;
		border: 0;
		font: inherit;
		font-size: var(--font-size);
		vertical-align: baseline;
	}
	/* HTML5 display-role reset for older browsers */
	article, aside, details, figcaption, figure,
	footer, header, hgroup, menu, nav, section {
		display: block;
	}
	ol, ul {
		list-style: none;
	}
	blockquote, q {
		quotes: none;
	}
	blockquote:before, blockquote:after,
	q:before, q:after {
		content: '';
		content: none;
	}
	table {
		border-collapse: collapse;
		border-spacing: 0;
	}
	* {
		box-sizing: border-box;
	}
	body {
		background: #FFFFFF;
		color: #3b4767;
		font-family: 'Montserrat', sans-serif;
		font-size: var(--font-size);
		line-height: 1.3;
        padding-top: var(--header-height);
	}
	img {
		display: block;
		width: 100%;
		height: auto;
	}
	a{
		color: inherit;
		text-decoration: none;
	}
	b{
		font-weight: bold;
	}
	button{
		font-family: inherit;
		font-size: 1rem;
		border: 2px solid transparent;
		background-color: transparent;
		cursor: pointer;
		outline-color: transparent;
		font-weight: 400;
	}

	input{
        outline: none;

		&::placeholder{
			color: #5B5B5B;
		}
	}
`;

export default GlobalStyle;